/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserAssignedLocationDto } from './userAssignedLocationDto';


export interface UserLoginInfoDto { 
    id?: number;
    name?: string | null;
    surname?: string | null;
    userName?: string | null;
    emailAddress?: string | null;
    assignedLocations?: Array<UserAssignedLocationDto> | null;
    roles?: Array<string> | null;
}

